export const asyncNoop = () => Promise.resolve();
